"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SteamVRTrackersSettingT = exports.SteamVRTrackersSetting = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class SteamVRTrackersSetting {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSteamVRTrackersSetting(bb, obj) {
        return (obj || new SteamVRTrackersSetting()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSteamVRTrackersSetting(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SteamVRTrackersSetting()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    waist() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    chest() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    automaticTrackerToggle() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    leftFoot() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rightFoot() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    leftKnee() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rightKnee() {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    leftElbow() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rightElbow() {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    leftHand() {
        const offset = this.bb.__offset(this.bb_pos, 30);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rightHand() {
        const offset = this.bb.__offset(this.bb_pos, 32);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startSteamVRTrackersSetting(builder) {
        builder.startObject(15);
    }
    static addWaist(builder, waist) {
        builder.addFieldInt8(0, +waist, +false);
    }
    static addChest(builder, chest) {
        builder.addFieldInt8(1, +chest, +false);
    }
    static addAutomaticTrackerToggle(builder, automaticTrackerToggle) {
        builder.addFieldInt8(6, +automaticTrackerToggle, +false);
    }
    static addLeftFoot(builder, leftFoot) {
        builder.addFieldInt8(7, +leftFoot, +false);
    }
    static addRightFoot(builder, rightFoot) {
        builder.addFieldInt8(8, +rightFoot, +false);
    }
    static addLeftKnee(builder, leftKnee) {
        builder.addFieldInt8(9, +leftKnee, +false);
    }
    static addRightKnee(builder, rightKnee) {
        builder.addFieldInt8(10, +rightKnee, +false);
    }
    static addLeftElbow(builder, leftElbow) {
        builder.addFieldInt8(11, +leftElbow, +false);
    }
    static addRightElbow(builder, rightElbow) {
        builder.addFieldInt8(12, +rightElbow, +false);
    }
    static addLeftHand(builder, leftHand) {
        builder.addFieldInt8(13, +leftHand, +false);
    }
    static addRightHand(builder, rightHand) {
        builder.addFieldInt8(14, +rightHand, +false);
    }
    static endSteamVRTrackersSetting(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSteamVRTrackersSetting(builder, waist, chest, automaticTrackerToggle, leftFoot, rightFoot, leftKnee, rightKnee, leftElbow, rightElbow, leftHand, rightHand) {
        SteamVRTrackersSetting.startSteamVRTrackersSetting(builder);
        SteamVRTrackersSetting.addWaist(builder, waist);
        SteamVRTrackersSetting.addChest(builder, chest);
        SteamVRTrackersSetting.addAutomaticTrackerToggle(builder, automaticTrackerToggle);
        SteamVRTrackersSetting.addLeftFoot(builder, leftFoot);
        SteamVRTrackersSetting.addRightFoot(builder, rightFoot);
        SteamVRTrackersSetting.addLeftKnee(builder, leftKnee);
        SteamVRTrackersSetting.addRightKnee(builder, rightKnee);
        SteamVRTrackersSetting.addLeftElbow(builder, leftElbow);
        SteamVRTrackersSetting.addRightElbow(builder, rightElbow);
        SteamVRTrackersSetting.addLeftHand(builder, leftHand);
        SteamVRTrackersSetting.addRightHand(builder, rightHand);
        return SteamVRTrackersSetting.endSteamVRTrackersSetting(builder);
    }
    unpack() {
        return new SteamVRTrackersSettingT(this.waist(), this.chest(), this.automaticTrackerToggle(), this.leftFoot(), this.rightFoot(), this.leftKnee(), this.rightKnee(), this.leftElbow(), this.rightElbow(), this.leftHand(), this.rightHand());
    }
    unpackTo(_o) {
        _o.waist = this.waist();
        _o.chest = this.chest();
        _o.automaticTrackerToggle = this.automaticTrackerToggle();
        _o.leftFoot = this.leftFoot();
        _o.rightFoot = this.rightFoot();
        _o.leftKnee = this.leftKnee();
        _o.rightKnee = this.rightKnee();
        _o.leftElbow = this.leftElbow();
        _o.rightElbow = this.rightElbow();
        _o.leftHand = this.leftHand();
        _o.rightHand = this.rightHand();
    }
}
exports.SteamVRTrackersSetting = SteamVRTrackersSetting;
class SteamVRTrackersSettingT {
    constructor(waist = false, chest = false, automaticTrackerToggle = false, leftFoot = false, rightFoot = false, leftKnee = false, rightKnee = false, leftElbow = false, rightElbow = false, leftHand = false, rightHand = false) {
        this.waist = waist;
        this.chest = chest;
        this.automaticTrackerToggle = automaticTrackerToggle;
        this.leftFoot = leftFoot;
        this.rightFoot = rightFoot;
        this.leftKnee = leftKnee;
        this.rightKnee = rightKnee;
        this.leftElbow = leftElbow;
        this.rightElbow = rightElbow;
        this.leftHand = leftHand;
        this.rightHand = rightHand;
    }
    pack(builder) {
        return SteamVRTrackersSetting.createSteamVRTrackersSetting(builder, this.waist, this.chest, this.automaticTrackerToggle, this.leftFoot, this.rightFoot, this.leftKnee, this.rightKnee, this.leftElbow, this.rightElbow, this.leftHand, this.rightHand);
    }
}
exports.SteamVRTrackersSettingT = SteamVRTrackersSettingT;
